import { useEffect, useState } from "react";
import {
  Input,
  Row,
  Typography,
  Col,
  Card,
  Select,
  Form,
  DatePicker,
  List,
} from "antd";
import dayjs from "dayjs";

const { Text } = Typography;

const ViewBranchForm = ({
  parentBranch = [],
  officeTypeOptions = [],
  nearestBranchOptions = [],
  countryIdData = [],
  stateProvinceIdData = [],
  addressTypeIdData = [],
  session,
  setIsLoading,
  cnt,
  apiConfig,
  BOM,
  selectedBranchKey,
}) => {
  const [form] = Form.useForm();
  const [addressList, setAddressList] = useState([]);

  useEffect(() => {
    getBranchById(selectedBranchKey.id);
  }, []);

  const getBranchById = (id) => {
    const url = `${apiConfig.OfficeOutlet}/${id}?template=true`;

    setIsLoading(true);
    BOM.FetchReqAction({ session }, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const { name, externalId, openingDate, parentId, officeTypeId, nearestBranchId, addresses } = res;

        const date = Array.isArray(openingDate)
          ? dayjs(new Date(openingDate[0], openingDate[1] - 1, openingDate[2]))
          : dayjs();

        form.setFieldsValue({
          name,
          externalId,
          openedOn: date,
          parentBranch: parentId || parentBranch[0]?.value,
          officeTypeId: officeTypeId || undefined,
          nearestBranchId: nearestBranchId || undefined,
        });

        if (Array.isArray(addresses) && addresses.length > 0) {
          const mapped = addresses.map((addr) => {
            const addressType = addressTypeIdData.find((o) => o.value === addr.addressTypeId);
            const stateProvince = stateProvinceIdData.find((o) => o.value === addr.stateProvinceId);
            const country = countryIdData.find((o) => o.value === addr.countryId);
            return {
              id: addr.addressTypeId,
              title: addressType?.label || addr.addressType?.name || "Address",
              description: [
                addr.addressLine1,
                addr.addressLine2,
                addr.city,
                stateProvince?.label || addr.stateName,
                country?.label || addr.countryName,
                addr.postalCode,
              ]
                .filter(Boolean)
                .join(", "),
            };
          });
          setAddressList(mapped);
        }

        setIsLoading(false);
      }
    });
  };

  return (
    <Form form={form} layout="vertical" style={{ paddingTop: 20 }}>
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginBottom: 24,
        }}
      >
        <div
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: "#9ca3af",
            letterSpacing: 1,
            textTransform: "uppercase",
            marginBottom: 14,
          }}
        >
          Branch Information
        </div>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="name" label={<Text strong>Branch</Text>}>
              <Input
                placeholder="—"
                style={{ height: 44 }}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="parentBranch" label={<Text strong>Parent Branch</Text>}>
              <Select
                placeholder="—"
                style={{ height: 44 }}
                options={parentBranch}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="officeTypeId" label={<Text strong>Office Type</Text>}>
              <Select
                placeholder="—"
                style={{ height: 44 }}
                options={officeTypeOptions}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="openedOn" label={<Text strong>Opened On</Text>}>
              <DatePicker
                style={{ width: "100%", height: 44 }}
                format="DD MMMM YYYY"
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="externalId" label={<Text strong>Branch Code</Text>}>
              <Input
                placeholder="—"
                style={{ height: 44 }}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="nearestBranchId" label={<Text strong>Nearest Branch</Text>}>
              <Select
                placeholder="—"
                style={{ height: 44 }}
                options={nearestBranchOptions}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>

      {addressList.length > 0 && (
        <Card
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <div
            style={{
              fontSize: 11,
              fontWeight: 700,
              color: "#9ca3af",
              letterSpacing: 1,
              textTransform: "uppercase",
              marginBottom: 14,
            }}
          >
            Address Information
          </div>

          <List
            dataSource={addressList}
            renderItem={(item) => (
              <Card
                style={{
                  width: "100%",
                  marginBottom: 12,
                  borderRadius: 12,
                  border: "1px solid #e5e7eb",
                }}
                bodyStyle={{ padding: "12px 16px" }}
              >
                <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 4 }}>
                  {item.title?.toUpperCase()}
                </div>
                <div style={{ color: "#6b7280", fontSize: 13 }}>{item.description}</div>
              </Card>
            )}
          />
        </Card>
      )}
    </Form>
  );
};

export default ViewBranchForm;
